import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@env/environment';
import { Observable } from 'rxjs';
import {CookieService} from 'ngx-cookie';
import {tap} from 'rxjs/operators';
import {ModalService} from '@services/modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private modalService: ModalService,
    private translate: TranslateService,
    private cookie: CookieService,
    ) {
  }

  private setUrl(url: string): string {
    if (url.startsWith('http')) {
      return url;
    } else if (new RegExp('i18n').test(url)) {
      return url;
    }

    return `${environment.apiUrl}/${url}`;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tkn = this.cookie.get('DWallUserToken');
    request = request.clone({
      url: this.setUrl(request.url),
      setHeaders: {
        Accept: 'application/json',
      }
    });

    if (tkn && request.url.indexOf('amazonaws') === -1) {
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${tkn}`,
        }
      });
    }


    return next
      .handle(request)
      .pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            // do stuff with response
          }
        })
      );
  }
}
